<template >
  <div
      style="width: 100%;height:100%"
      v-html="displayVal" ></div >
</template >
<script >
export default {
  name: 'QsTd',
  props: {

    colProps: {}
  },
  computed:{
    displayVal() {
      let val=this.colProps.value, props=this.colProps
      const colDefs = props.col
      let row = props.row
      // _log_('render val...', colDefs)
      // return  val
      const vm = this;

      if (!row || (row.idx && (row.idx + "").indexOf("gap") === 0)) return;
      if (colDefs.formatterType == "unxToDate") return this.formatDate(val);
      else if (colDefs.formatter) {
        return colDefs.formatter(val, colDefs, row, vm, this.tableData);
      }
      if (val === null || val === undefined) return "&nbsp;";
      if (colDefs.labelProp) val = row(colDefs.labelProp);

      const editor = colDefs.editorcomponent;
      if (editor)
        switch (editor.is) {
          case "s-select":
            if (!val || val == "" || val == 0) return "&nbsp;";
            if (editor.valueProp == "raw") return val;
            var avOptions = null;
            if (editor.optionsRepo) {
              avOptions = this.getList(editor.optionsRepo);
            }
            else avOptions = editor.options;

            var q = {};
            q[editor.valueProp] = val + "";
            var o = _.find(avOptions, q);
            if (o) return o[editor.labelProp];
            else {
              q[editor.valueProp] = val;
              o = _.find(avOptions, q);
              if (o) return o[editor.labelProp];
            }
            return "?" + val;
            break;

          default:
            break;
        }

      return val && val != "" ? val : "<div> &nbsp;</div>";
    },
  }
}
</script >
